import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Injectable({
  providedIn: 'root'
})
export class isOnlineMedicalNetworkGuard implements CanActivate {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) appConfigTemp: EnvironmentModel, private router: Router) {
    this.appConfig = appConfigTemp;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.appConfig.onlyMedicalNetwork) {
      this.router.navigate(['services']);
      return false;
    }

    return true;
  }
}
